@if (profile) {
  <div class="profile__header">
    @if (image && !imageLoadFailed) {
      <div class="profile__media">
        <img alt="Profile picture" width="66" height="66" [src]="image" (error)="onError()" />
        <img
          alt="Profile picture"
          width="66"
          height="66"
          class="profile__media-hover"
          [src]="image" />
      </div>
    } @else {
      <div class="profile__media">
        <div class="media-placeholder medium">
          <span class="media-placeholder__text">
            <app-candidate-name
              [name]="profile.fullName"
              [getNameAbbreviation]="true"></app-candidate-name>
          </span>
        </div>
      </div>
    }
    <div class="candidate-intro">
      <h1 class="main-title">
        {{ profile.fullName | emojiCleaner }}
      </h1>
      <span class="candidate-position">
        {{ profile.headLine | emojiCleaner }}
      </span>
      <span class="secondary-title candidate-location">
        {{ profile.location | location }}
      </span>
    </div>
  </div>
}
